import { create } from "zustand";


const defaultValues = {
  isOpen: false,
};

interface IuseRangePicker {
  onToggleRangePicker: () => void;
  onCloseRangePicker: () => void;
  initialValues: typeof defaultValues;
}

export const useRangePicker = create<IuseRangePicker>((set) => ({
  initialValues: defaultValues,
  onToggleRangePicker: () =>
    set((prevState) => ({
      initialValues: {
        ...prevState.initialValues,
        isOpen: !prevState.initialValues.isOpen,
      },
    })),
  onCloseRangePicker: () =>
    set({ initialValues: { isOpen: false } }),
}));
